import {
  CATALOG_BOOKSET_DETAIL_SET_DATA,
  CATALOG_BOOKSET_DETAIL_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  bookset: null,
  books: null,
  paginateBy: 48,
  pageNumber: 1,
  lastPageNumber: 0,
  rubrics: [],
};

export default function boksetDetail(state = initialState, action) {
  switch (action.type) {
    case CATALOG_BOOKSET_DETAIL_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_BOOKSET_DETAIL_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
